<template>
<div class="align-right">
    <ihlp-page :current="pageVO.curPage" :page-size="pageVO.pageSize"  :total="pageVO.totalRows" show-elevator show-sizer show-total @on-change="onChange" @on-page-size-change="onPageChange"></ihlp-page>
</div>
</template>
<script>
import ihlpPage from './page/page.vue'
    export default {
        name:"pageVO",
        props:{
            pageVO:{
                type: Object,
                default: function () {
                    return {
                        //当前页码
                        curPage: 1,
                        //每页条数
                        pageSize: 10,
                        //数据总数
                        totalRows: 0
                    }
                }
            }
        },
        components: { ihlpPage},
        methods:{
            //页码改变事件
            onChange(value){
                this.$emit('pageVOChange', {curPage:value});
            },
            //每页条数改变事件
            onPageChange(value){
                this.$emit('pageVOChange', {pageSize:value});
            }
        },
        watch: { 
            "pageVO.curPage"(newValue,oldValue){
                if (newValue == '-1'){
                    this.pageVO.curPage=1
                    this.pageVO.totalRows=0
                    if(oldValue!='1'){
                        this.$emit('pageVOChange', {curPage:1});
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/pageVO.vue